import { render, staticRenderFns } from "./QuestionsIndex.vue?vue&type=template&id=5bd4d958&scoped=true"
import script from "./QuestionsIndex.vue?vue&type=script&lang=js"
export * from "./QuestionsIndex.vue?vue&type=script&lang=js"
import style0 from "./QuestionsIndex.vue?vue&type=style&index=0&id=5bd4d958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd4d958",
  null
  
)

export default component.exports